import { type FC } from 'react';

import { StatusPin } from '@entities/marketplace';

import { Flex } from '@shared/ui-kit';

import {
  MarketplaceStatus,
  type MerchantMarketplaceCounters,
} from '@api/services/merchants';

interface Props {
  marketplace_counters?: MerchantMarketplaceCounters;
}

const StatusPins: FC<Props> = ({ marketplace_counters }) => {
  if (!marketplace_counters || !marketplace_counters.total) {
    return null;
  }

  const statusPins: MarketplaceStatus[] = [
    MarketplaceStatus.HasCriticalChanges,
    MarketplaceStatus.ReadyForCheck,
    MarketplaceStatus.Postponed,
    MarketplaceStatus.Processing,
    MarketplaceStatus.Pending,
    MarketplaceStatus.Finished,
  ];

  return (
    <Flex
      data-testid="status-pins"
      as="ul"
      direction="column"
      position="absolute"
      top="0"
      left="-6"
      rowGap="1.5"
      justify="center"
      h="full"
      w="fit-content"
    >
      {statusPins.map((status) => {
        return (
          <StatusPin
            key={status}
            status={status}
            value={marketplace_counters[status]}
          />
        );
      })}
    </Flex>
  );
};

export default StatusPins;
